import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

export default function ReadmissionApplicationSuccess() {
  const { oid } = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    document.title = '复学申请'
  }, [])

  const handleReturn = () => {
    navigate('/' + oid)
  }

  return (
    <div className='result-page'>
      <div className='result-icon'>
        <img src="/images/chenggong.png" alt="" />
      </div>
      <div className='result-title'>提交成功</div>
      <div className='result-description'>
        提交成功，请及时关注初审进度，审核结果可以通过上级页面的“结果查询”功能查看。超过3个工作日未审核请电话联系021-50210897。
      </div>
      <div className='result-button' onClick={handleReturn}>返回</div>
    </div>
  )
}
